// Slow editorial marquee
export const Marquee = ({ items, tone = "dark" }) => {
  const row = [...items, ...items];
  const isDark = tone === "dark";
  return (
    <div
      data-testid="editorial-marquee"
      className={`py-6 overflow-hidden border-y ${isDark ? "bg-navy border-[#24355A]" : "bg-cream-ivory border-[#E2DACB]"}`}
    >
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-serif italic text-3xl md:text-5xl px-8 ${isDark ? "text-parchment" : "text-navy"}`}
            >
              {t}
            </span>
            <span className="text-gold text-2xl md:text-3xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
